export const CLEAR_PAYMENTS_STATE = "CLEAR_PAYMENTS_STATE";

export const TOGGLE_FETCHING_PAYMENTS = "TOGGLE_FETCHING_PAYMENTS";
export const SET_PAYMENTS = "SET_PAYMENTS";
export const SET_SELECTED_PAYMENT = "SET_SELECTED_PAYMENT";
export const CREATE_PAYMENT = "CREATE_PAYMENT";

export const TOGGLE_FETCH_PAYMENT_REQUEST = "TOGGLE_FETCH_PAYMENT_REQUEST";
export const SET_PAYMENT_REQUEST = "SET_PAYMENT_REQUEST";
